/* Claim je korting: de pop-up op de vloeren-PDP.

   Het blok zelf rendert server-side (snippets/solza-vloer-claim.liquid);
   dit script doet alleen de dialog, de validatie en het versturen.

   Versturen gaat langs twee routes, en de bedankmelding verschijnt pas als
   een van beide gelukt is:
   1. klaviyo.js uit de Klaviyo-app: identify en daarna track. Dit is de
      route die de Klaviyo-flow verwacht.
   2. Vangnet: is klaviyo.js er niet (adblocker), faalt de track, of duurt
      het langer dan vijf seconden, dan hetzelfde event rechtstreeks via de
      Client API.

   Eventnaam en propertynamen staan hier vast en zijn niet instelbaar: de
   flow in Klaviyo bouwt erop, en een typefout in de editor zou de keten
   stil breken. */
(function () {
  'use strict';

  var EVENT_NAAM = 'Kortingscode aangevraagd';
  var BRON = 'Claim je korting PDP';
  var REVISION = '2025-07-15';
  var TIMEOUT_MS = 5000;
  var LANDCODES = { NL: '31', BE: '32', DE: '49', FR: '33', LU: '352', AT: '43', CH: '41' };

  var dialogs = document.querySelectorAll('[data-solza-claim-dialog]');
  if (!dialogs.length) return;

  /* Leest "28", "28,5" of "28.5". Nul of onleesbaar wordt 0. */
  function leesGetal(waarde) {
    var n = parseFloat(String(waarde || '').trim().replace(',', '.'));
    return isNaN(n) || n <= 0 ? 0 : n;
  }

  function toonGetal(n) {
    return String(Math.round(n * 100) / 100).replace('.', ',');
  }

  /* Naar E.164: +31612345678. Klaviyo weigert de hele meting bij een
     nummer dat daar niet aan voldoet, dus dit gebeurt altijd vóór het
     versturen. Geeft null bij een ongeldig nummer. */
  function normaliseerTelefoon(invoer, land) {
    var t = String(invoer || '').replace(/[\s\-().\/]/g, '');
    if (!t) return '';
    if (t.indexOf('00') === 0) t = '+' + t.slice(2);
    else if (t.charAt(0) === '0') t = '+' + (LANDCODES[land] || '31') + t.slice(1);
    return /^\+\d{9,15}$/.test(t) ? t : null;
  }

  function geldigEmail(invoer, veld) {
    var e = String(invoer || '').trim();
    return !!e && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e) && (!veld || veld.checkValidity());
  }

  /* De public key uit de instelling, en anders die uit de URL waarmee de
     Klaviyo-app klaviyo.js laadt. */
  function klaviyoSleutel(config) {
    if (config.klaviyoKey) return config.klaviyoKey;
    var s = document.querySelector('script[src*="klaviyo.com"][src*="company_id="]');
    var m = s && s.src.match(/company_id=([A-Za-z0-9]+)/);
    return m ? m[1] : '';
  }

  function calculatorVeld() {
    return document.querySelector('[data-solza-rekenhulp] [data-solza-m2]');
  }

  function huidigeVariant(config) {
    var veld = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = veld ? String(veld.value) : String(config.event.VariantID);
    var v = config.varianten && config.varianten[id];
    return v ? { id: Number(id), sku: v.sku, prijsM2: v.prijsM2 } : null;
  }

  function metTimeout(belofte, ms) {
    return Promise.race([
      belofte,
      new Promise(function (_, weiger) {
        setTimeout(function () { weiger(new Error('timeout')); }, ms);
      })
    ]);
  }

  Array.prototype.forEach.call(dialogs, function (dialog) {
    var blok = dialog.previousElementSibling && dialog.previousElementSibling.matches('[data-solza-claim]')
      ? dialog.previousElementSibling
      : document.querySelector('[data-solza-claim]');
    var dataEl = dialog.parentNode.querySelector('[data-solza-claim-data]');
    if (!blok || !dataEl) return;
    var config;
    try { config = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = dialog.querySelector('[data-solza-claim-form]');
    var bedankt = dialog.querySelector('[data-solza-claim-bedankt]');
    var foutEl = dialog.querySelector('[data-solza-claim-fout]');
    var knop = dialog.querySelector('[data-solza-claim-verstuur]');
    var velden = { voornaam: form.elements.voornaam, m2: form.elements.m2, email: form.elements.email, telefoon: form.elements.telefoon };

    function toonFout(tekst) {
      foutEl.textContent = tekst;
      foutEl.hidden = false;
    }
    function wisFout() {
      foutEl.hidden = true;
      foutEl.textContent = '';
    }

    function open() {
      wisFout();
      form.hidden = false;
      bedankt.hidden = true;
      var bron = calculatorVeld();
      var m2 = bron ? leesGetal(bron.value) : 0;
      if (m2) velden.m2.value = toonGetal(m2);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      /* De cursor in het eerste veld dat nog leeg is, zodat een m² die
         uit de rekenhulp is overgenomen niet opnieuw wordt gevraagd. */
      var eerste = [velden.voornaam, velden.m2, velden.email, velden.telefoon].filter(Boolean);
      for (var i = 0; i < eerste.length; i++) {
        if (!eerste[i].value) { eerste[i].focus(); return; }
      }
      eerste[0].focus();
    }

    function sluit() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    blok.querySelectorAll('[data-solza-claim-open]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    dialog.querySelectorAll('[data-solza-claim-sluit]').forEach(function (b) {
      b.addEventListener('click', sluit);
    });
    /* Klik op de achtergrond: de dialog zelf heeft geen padding, dus een
       klik die op het dialog-element landt valt buiten de inhoud. */
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) sluit();
    });
    /* Esc sluiten we zelf. Een ander script op de pagina roept
       preventDefault aan op elke Escape-toets, en dan sluit een native
       dialog niet meer uit zichzelf. */
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        sluit();
      }
    });
    /* Na een geslaagde aanvraag en sluiten staat bij de volgende keer
       openen het formulier weer klaar. */
    dialog.addEventListener('close', function () {
      if (!bedankt.hidden) {
        form.reset();
        form.hidden = false;
        bedankt.hidden = true;
      }
      var opener = blok.querySelector('[data-solza-claim-open]');
      if (opener) opener.focus();
    });
    form.addEventListener('input', wisFout);

    /* m2 terug naar de calculator, met hetzelfde event dat typen geeft, zodat
       totaalprijs, minimum, snijverlies en de knopstatus meerekenen. Het
       veld is type="number": de waarde moet een punt als decimaalteken
       hebben. */
    function zetM2Terug(m2) {
      var doel = calculatorVeld();
      if (!doel) return;
      doel.value = String(Math.round(m2 * 100) / 100);
      doel.dispatchEvent(new Event('input', { bubbles: true }));
      doel.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function clientApi(pad, body) {
      var sleutel = klaviyoSleutel(config);
      if (!sleutel) return Promise.reject(new Error('geen Klaviyo public key'));
      return fetch('https://a.klaviyo.com/client/' + pad + '/?company_id=' + encodeURIComponent(sleutel), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: REVISION },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('Klaviyo ' + r.status);
        return r;
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      wisFout();

      var voornaam = velden.voornaam ? String(velden.voornaam.value || '').trim() : '';
      var m2 = leesGetal(velden.m2.value);
      var email = String(velden.email.value || '').trim();
      var telInvoer = velden.telefoon ? String(velden.telefoon.value || '').trim() : '';
      var telefoon = normaliseerTelefoon(telInvoer, config.land);

      if (velden.voornaam && voornaam.length < 2) { toonFout(config.fouten.voornaam); velden.voornaam.focus(); return; }
      if (!m2) { toonFout(config.fouten.m2); velden.m2.focus(); return; }
      if (!geldigEmail(email, velden.email)) { toonFout(config.fouten.email); velden.email.focus(); return; }
      if ((config.telefoonVerplicht && !telInvoer) || telefoon === null) { toonFout(config.fouten.telefoon); velden.telefoon.focus(); return; }

      knop.disabled = true;
      form.setAttribute('aria-busy', 'true');

      var variant = huidigeVariant(config);
      var props = {};
      Object.keys(config.event).forEach(function (k) { props[k] = config.event[k]; });
      if (variant) {
        props.SKU = variant.sku;
        props.VariantID = variant.id;
        props['Prijs per m2'] = variant.prijsM2;
      }
      props['Aantal m2'] = m2;
      props.Telefoonnummer = telefoon || '';
      props.Bron = BRON;

      /* De voornaam hoort bij het profiel en niet bij de aanvraag, dus
         hij gaat mee in identify en in beide profielen, en niet als
         event-property. */
      var profiel = { email: email };
      if (voornaam) profiel.first_name = voornaam;
      if (telefoon) profiel.phone_number = telefoon;

      /* Route 1: klaviyo.js. */
      function viaKlaviyoJs() {
        var k = window.klaviyo;
        if (!k || typeof k.identify !== 'function' || typeof k.track !== 'function') {
          return Promise.reject(new Error('klaviyo.js niet beschikbaar'));
        }
        var poging = Promise.resolve(k.identify(profiel))
          .then(function () { return k.track(EVENT_NAAM, props); })
          .then(function (ok) { if (ok === false) throw new Error('track mislukt'); });
        return metTimeout(poging, TIMEOUT_MS);
      }

      /* Route 2: de Client API, hetzelfde event. */
      function viaClientApi() {
        return clientApi('events', {
          data: {
            type: 'event',
            attributes: {
              metric: { data: { type: 'metric', attributes: { name: EVENT_NAAM } } },
              profile: { data: { type: 'profile', attributes: profiel } },
              properties: props
            }
          }
        });
      }

      var aanvraag = viaKlaviyoJs().catch(viaClientApi);

      /* De aanmelding hoort bij elke aanvraag: de korting is het
         welkomstcadeau, en dat staat zo in de pop-up. Zonder lijst-ID
         kan hij nergens heen en blijft hij weg; een fout erin mag de
         kortingsaanvraag nooit blokkeren. */
      var aanmelding = config.lijstId
        ? clientApi('subscriptions', {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: BRON,
                profile: {
                  data: {
                    type: 'profile',
                    attributes: voornaam
                      ? {
                          email: email,
                          first_name: voornaam,
                          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                        }
                      : {
                          email: email,
                          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                        }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: config.lijstId } } }
            }
          }).catch(function () {})
        : Promise.resolve();

      aanvraag
        .then(function () {
          return aanmelding;
        })
        .then(function () {
          zetM2Terug(m2);
          form.hidden = true;
          bedankt.hidden = false;
          var titel = bedankt.querySelector('[data-solza-claim-bedankt-titel]');
          if (titel) titel.focus();
        })
        .catch(function () {
          toonFout(config.fouten.versturen);
        })
        .then(function () {
          knop.disabled = false;
          form.removeAttribute('aria-busy');
        });
    });
  });
})();
